import { useDispatch } from 'react-redux';
import { useAuth0 } from '@auth0/auth0-react';
import { useBooleanFlagValue } from '@openfeature/react-sdk';
import moment from 'moment';

import { TREATMENT_PLAN_BASE_PATH } from '../../../../../constants';
import { FeatureFlags } from '../../../../../constants/featureFlags';
import { history } from '../../../../../helpers';
import { treatmentPlanActions, treatmentPlanV3Actions } from '../../../../../store';

import type { AppDispatch } from '../../../../../store';
import type { CreateTreatmentPlan } from './types';

export default function useCreateTreatmentPlan(): CreateTreatmentPlan {
  const dispatch = useDispatch<AppDispatch>();
  const { getAccessTokenSilently } = useAuth0();
  const isTreatmentPlanV3Enabled = useBooleanFlagValue(
    FeatureFlags.TREATMENT_PLAN_V3_ENABLED,
    false,
  );

  return async (clientId, bay, cloneSourceTreatmentPlanId) => {
    if (isTreatmentPlanV3Enabled) {
      const response = await dispatch(
        treatmentPlanV3Actions.createTreatmentPlanV3({
          data: {
            client_id: clientId,
            bay,
            intake_questionnaire_id: null,
            clone_source_tp_id: cloneSourceTreatmentPlanId,
          },
          getAccessTokenSilently,
        }),
      );
      if (response.error) return false;
      history.navigate(`${TREATMENT_PLAN_BASE_PATH}/${response.payload.id}`);
      return true;
    }

    const response = await dispatch(
      treatmentPlanActions.createTreatmentPlan({
        data: {
          client_id: clientId,
          date_start_authorization_recommended: moment(new Date()),
          date_end_authorization_recommended: moment(new Date()).add(6, 'M'),
          bay,
          clone_source_tp_id: cloneSourceTreatmentPlanId,
        },
        getAccessTokenSilently,
      }),
    );
    return !response.error;
  };
}
